import React, { useEffect, useState } from 'react';
import css from './../css/recording_components.module.css'
const GetAutoTurbidity = (props) => {
  // the loading state, if 0, image not loaded or the exam could not be loaded and requires reload, and button can be clicked,
  // if 1, image is loading, button cannot be clicked.
  // if 2, image loaded completed, button cannot be clicked.
  const [load, setLoad] = useState(props.loading);
  // the message that displays the status.
  const [responseMessage, setResponseMessage] = useState(props.responseMessage);

  useEffect(() => {
    setLoad(props.loading);
    setResponseMessage(props.responseMessage);
  }, [props.loading, props.responseMessage]);

  const handleClick = () => {
    props.handleGetReport();
  };
  
  return (
    <div>
      <button style={load === 2 ? { display: "none" } : { display: "block"}} onClick={handleClick} disabled={load == 1 || load === 2 || load == 3} className={`${css.ui_button} ${css.get_at_button}`}>
        {load == 1 ? 'Loading...' : (load == 0 ? "Auto Turbidity" : load == 3 ? "Unable to generate Auto Turbidity from this exam": responseMessage)}
      </button>
    </div>
  );
};

export default GetAutoTurbidity;
